






































import {
  getCurrentInstance,
  ComponentInternalInstance,
  computed,
  defineComponent,
  onUnmounted,
  ref,
  watch,
  Ref,
  onMounted,
} from '@vue/composition-api';

// 引入组件
import CollaborationMemberManage from '@/renderer/components/drawer/MemberManage/CollaborationMemberManage.vue';

// 引入 compositions
import authHandler from '@/renderer/components/SpacePage/compositions/authHandler';
import historyHandler from '@/renderer/components/SpacePage/compositions/historyHandler';
import downloadHandler from '@/renderer/components/SpacePage/compositions/downloadHandler';
import openPreviewHandler from '@/renderer/components/SpacePage/compositions/openPreviewHandler';

// 引入工具类
import { SelectableFileItem } from '@/renderer/components/drawer/compositions/selectableFileItem';
import { FileSelectHandler } from '@/renderer/components/drawer/compositions/fileSelectHandler';
import { DrawerEvents } from '@/renderer/store/modules/drawer';
import EmptyDetail from './Detail/EmptyDetail.vue';
import LinkDetail from './Detail/LinkDetail.vue';
import History from './History/index.vue';
import Detail from './Detail/index.vue';
import MultiSelect from './MultiSelect/index.vue';
import NoSelected from './NoSelected/index.vue';
import Dynamic from './Dynamic/index.vue';
import FileMemberManage from './MemberManage/FileMemberManage.vue';
import Workbench from './WorkbenchDynamic/index.vue';
import FileListIndicator from './components/FileList/FileListIndicator/index.vue';
import FileListSelector from './components/FileList/FileListSelector/index.vue';
import TeamMemberMange from './MemberManage/TeamMemberMange.vue';

import CoSyncRecordDrawer from './CoSyncRecord/index.vue';

export default defineComponent({
  name: 'drawer',
  props: {
    withTopPadding: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    TeamMemberMange,
    Dynamic,
    FileMemberManage,
    CollaborationMemberManage,
    Detail,
    EmptyDetail,
    History,
    MultiSelect,
    NoSelected,
    Workbench,
    LinkDetail,
    FileListIndicator,
    FileListSelector,
    CoSyncRecordDrawer,
  },
  setup(props, context) {
    // 解构 props
    // const { spaceId } = toRefs(props);
    const currComponent = getCurrentInstance() as ComponentInternalInstance;
    const vm = currComponent.proxy;

    // 文件切换处理
    const fileSelectHandler = new FileSelectHandler();
    const selectedList = computed(() => vm.$store.getters.drawerSelected || []);
    const teamId = computed(() => vm.$route.query?.teamId || vm.$store.state.drawer.teamId);
    const type = computed(() => vm.$store.state.drawer.type);
    const getDrawerTabs = () => vm.$store.state.drawer.tabs;
    const total = computed(() => vm.$store.state.drawer.total);
    // 单选节点
    const singleItem = computed(() => (selectedList.value.length === 1 ? selectedList.value[0] : null));
    const spaceId = computed(
      () => vm.$route.query?.spaceId || vm.$store.state.drawer.spaceId || (singleItem.value as any)?.spaceId,
    );
    const drawers: Ref<Drawer.Scope<unknown>[]> = ref([]);

    // 默认值为 第一个tab
    const tabName = ref<string>(drawers.value.length > 0 ? drawers.value[0].title : '');
    const subtitle = computed<string | undefined>(() =>
      drawers.value.length > 0 ? drawers.value[0].subtitle : undefined,
    );

    // 显示标题数组
    const titles = computed<string[]>(() => drawers.value.map(item => item.title));
    // 组件名称数组
    const componentNames = computed<string[]>(() => drawers.value.map(item => item.componentName));

    // 是否展示文件指示器
    const shouldShowFileIndicator = computed(() => vm.$store.state.drawer.fileSwitchConfig !== null);

    const isShowingSyncHistory = computed(
      () =>
        drawers.value.find(it => it.title === tabName.value && it.componentName === 'CoSyncRecordDrawer') !== undefined,
    );

    // 设置默认的drawers
    watch(titles, (val: string[]) => {
      if (!val || val.length === 0) return;
      // 是否匹配到上一个tab页中的内容
      const matchOldTitle = titles.value.filter((title: string) => title === tabName.value);
      if (matchOldTitle.length === 0) {
        // 若没有匹配到，则默认第0个
        [tabName.value] = titles.value;
      }
    });
    watch(
      () => vm.$store.state.drawer.drawers,
      val => {
        drawers.value = val;
      },
      {
        immediate: true,
      },
    );

    // 监听文件选择配置的变化
    watch(
      () => vm.$store.state.drawer.fileSwitchConfig,
      newConfig => {
        const config = newConfig as Drawer.FileListSwitchConfig | null;
        if (config) {
          fileSelectHandler.updateSelectConfig(config);
        }
      },
    );
    watch(
      () => fileSelectHandler.selectedFile.value,
      (newSelectedFile: SelectableFileItem | null) => {
        if (!newSelectedFile) return;
        vm.$store.commit(DrawerEvents.SET_DRAWERS_FILE_INDICATOR_SELECTED, newSelectedFile.file);
      },
    );

    watch(tabName, (val: string) => {
      drawers.value.forEach(element => {
        if (element.title === val) {
          vm.$store.commit(DrawerEvents.DRAWER_SELECTED_TAB, element);
        }
      });
    });

    const { show: showAuth, dirPermisionList, loading: shareLoading, methods: authMethods } = authHandler(spaceId);
    const { loading: historyLoading, list: historyList } = historyHandler(spaceId);
    onMounted(() => {
      const config = vm.$store.state.drawer.fileSwitchConfig as Drawer.FileListSwitchConfig | null;
      if (config) {
        fileSelectHandler.updateSelectConfig(config);
      }
    });
    onUnmounted(() => authMethods.reset());
    return {
      drawers,
      componentNames,
      titles,
      tabName,
      subtitle,
      selectedList,
      type,
      total,
      showAuth,
      shareLoading,
      dirPermisionList,
      authMethods,
      spaceId,
      teamId,
      historyLoading,
      historyList,
      getDrawerTabs,
      singleItem,
      shouldShowFileIndicator,
      fileSelectHandler,
      isShowingSyncHistory,
    };
  },
});
